import { render, staticRenderFns } from "./LearnIt.vue?vue&type=template&id=3c70f8b8"
import script from "./LearnIt.vue?vue&type=script&lang=js"
export * from "./LearnIt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports